import { UserDataLayerAdapter } from "../shared/UserDataLayerAdapter";
import { User } from "../gtm/User";
import { singleton } from "tsyringe";

@singleton()
export class DotCaUserDataLayerAdapter extends UserDataLayerAdapter {
  constructor(user: User) {
    super(user);
  }
}
